/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParcImmobilierMinimalDto } from './ParcImmobilierMinimalDto';
import {
    ParcImmobilierMinimalDtoFromJSON,
    ParcImmobilierMinimalDtoFromJSONTyped,
    ParcImmobilierMinimalDtoToJSON,
    ParcImmobilierMinimalDtoToJSONTyped,
} from './ParcImmobilierMinimalDto';

/**
 * 
 * @export
 * @interface ReadListParcsResponseDto
 */
export interface ReadListParcsResponseDto {
    /**
     * Liste des parcs du courtier courant (vue minimale)
     * @type {Array<ParcImmobilierMinimalDto>}
     * @memberof ReadListParcsResponseDto
     */
    realEstateParks: Array<ParcImmobilierMinimalDto>;
}

/**
 * Check if a given object implements the ReadListParcsResponseDto interface.
 */
export function instanceOfReadListParcsResponseDto(value: object): value is ReadListParcsResponseDto {
    if (!('realEstateParks' in value) || value['realEstateParks'] === undefined) return false;
    return true;
}

export function ReadListParcsResponseDtoFromJSON(json: any): ReadListParcsResponseDto {
    return ReadListParcsResponseDtoFromJSONTyped(json, false);
}

export function ReadListParcsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadListParcsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'realEstateParks': ((json['realEstateParks'] as Array<any>).map(ParcImmobilierMinimalDtoFromJSON)),
    };
}

export function ReadListParcsResponseDtoToJSON(json: any): ReadListParcsResponseDto {
    return ReadListParcsResponseDtoToJSONTyped(json, false);
}

export function ReadListParcsResponseDtoToJSONTyped(value?: ReadListParcsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realEstateParks': ((value['realEstateParks'] as Array<any>).map(ParcImmobilierMinimalDtoToJSON)),
    };
}

